import type { InteractionWithAuthor, TypeInteraction } from '@cockpit/shared';
import { formatDate } from '../../lib/format';

const ICONS: Record<TypeInteraction, string> = {
  Appel: '📞',
  Email: '✉️',
  Visite: '🚗',
  Salon: '🎪',
  Autre: '📝',
};

interface Props {
  items: InteractionWithAuthor[];
  onDelete?: (id: number) => void;
}

export function InteractionList({ items, onDelete }: Props): JSX.Element {
  if (items.length === 0) {
    return (
      <div className="text-sm text-slate-500 italic text-center py-6">
        Aucune interaction enregistrée.
      </div>
    );
  }
  return (
    <ul className="flex flex-col gap-2">
      {items.map((i) => (
        <li
          key={i.id}
          className="bg-slate-900/40 border border-slate-800 rounded-md p-3 flex items-start gap-3"
        >
          <div className="text-xl leading-none mt-0.5">{ICONS[i.type_interaction]}</div>
          <div className="flex-1 min-w-0">
            <div className="flex items-baseline justify-between gap-2">
              <div className="text-xs text-slate-500">
                <span className="text-slate-300 font-medium">{i.type_interaction}</span>
                {' · '}
                {formatDate(i.date_interaction)}
                {' · '}
                {i.created_by_username}
              </div>
              {onDelete !== undefined && (
                <button
                  type="button"
                  onClick={(): void => onDelete(i.id)}
                  className="text-xs text-slate-500 hover:text-red-400"
                >
                  Supprimer
                </button>
              )}
            </div>
            <div className="text-sm text-slate-200 mt-1 whitespace-pre-wrap break-words">
              {i.resume}
            </div>
            {i.prochaine_etape !== null && i.prochaine_etape !== '' && (
              <div className="text-xs text-slate-400 mt-1">
                → Prochaine étape : {i.prochaine_etape}
              </div>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
}
